CKEDITOR.config.toolbar = [
    ['Format', 'Bold', 'Italic', 'Underline', 'NumberedList', 'BulletedList']
] ;

let detailedDescription = document.getElementById('AboutExperienceStepForm_AboutExperienceStepForm_DetailedDescription');
if (detailedDescription) {
    CKEDITOR.replace(detailedDescription);
}

let describeBusiness = document.getElementById('AboutBusinessStepForm_AboutBusinessStepForm_DescribeBusiness');
if (describeBusiness) {
    CKEDITOR.replace(describeBusiness);
}


let sustainability = document.getElementById('AboutBusinessStepForm_AboutBusinessStepForm_Sustainability');
if (sustainability) {
    CKEDITOR.replace(sustainability);
}


// ****** START - word count validation ********

let field = $('.js-word-count-field');

//start - textarea words validation
if (field) {
    field.on('input', function (e){
        e.preventDefault();
        if ($(this).val()) {
            let string = $(this).val().split(/[\s]+/);
            let wordsCount = $(this).attr('words-count');
            let left = parseInt(wordsCount) - parseInt(string.length)
            let textarea = $(this).closest('.middleColumn').closest('.js-word-count-field')
            if (left >= 0) {
                textarea.find('.js-word-count-error').remove();
                $("<div class='message error js-word-count-error'></div>").appendTo(textarea);
                textarea.find('.js-word-count-error').text('Remaining '+ left + ' Words')
            }else  {
                textarea.find('.js-word-count-error').text('Exceeded the maximum word limit')
            }
        }
    })
}
//end - textarea words validation


//start - ckeditor words validation
for (let i in CKEDITOR.instances) {

    CKEDITOR.instances[i].on('change', function() {
        let string = this.getData().replace(/(<([^>]+)>)/ig,'').replace('&nbsp;', '');
        let words = string.split(' ');
        let wordsCount = $(this.element.$).attr('words-count');
        let left = parseInt(wordsCount) - parseInt(words.length)

        let ckfield = $(this.element.$).closest('.middleColumn').closest('.ck-editor.js-word-count-field');

        if (left >= 0) {
            ckfield.find('.js-word-count-error').remove();
            $("<div class='message error js-word-count-error'></div>").appendTo(ckfield);
            ckfield.find('.js-word-count-error').text('Remaining '+ left + ' Words')
        }else  {
            ckfield.find('.js-word-count-error').text('Exceeded the maximum word limit')
        }
    });
}
//end - ckeditor words validation

// ****** END - word count validation ********